import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import UrlHandlerApiService from "./url-handler.service";

const ProductsApiService = {
  URL: "",
  async init() {
    Vue.use(VueAxios, axios);
    this.URL = await UrlHandlerApiService.getBaseUrl();
  },

  getAllProducts(params = {}) {
    return Vue.axios.get(`${this.URL}/api/shop/admin/shop-visited/all-items`, { params });
  }
};

export default ProductsApiService;
